import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/conditionItemTypes', request)
}

export {get}
